import React from "react";

export const AnimatedBackground = () => (
  <div className="fixed inset-0 -z-10" aria-hidden="true" data-testid="animated-bg" style={{ background: "var(--pt-bg)" }} />
);
